import React, { useEffect } from 'react';
import styles from './Popup.module.css';

const Popup = ({ isOpen, onClose, children }) => {
    useEffect(() => {
        if (isOpen) document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className={styles.popupOverlay} onClick={onClose}>
            <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose}>
                    <img src="/images/cross.svg" alt="Закрыть"/>
                </button>
                {children}
            </div>
        </div>
    );
};

export default Popup;
